export default __webpack_public_path__ + "static/media/FuelPumps.37dc1abb.pdf";